import { render, staticRenderFns } from "./FeatureRequests.vue?vue&type=template&id=70e81da5&scoped=true"
import script from "./FeatureRequests.vue?vue&type=script&lang=js"
export * from "./FeatureRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e81da5",
  null
  
)

export default component.exports